import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import ToggleButton from "react-toggle-button";
import Api from "../../../Services/Api";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleUploadExcel from "../../../modules/upload/SimpleUploadExcel";
import {HttpStatus, Status} from "../../common/Constants";
import {
    flattenFormGroupObject,
    getValueFromDDL,
    mapToObjectDDL,
    removeNullFields,
} from "../../common/mapper";
import {formGroup} from "./Config";
import MasterPartModifying from "./masterPartModifying";
import MasterPartFilter from "./masterPartFilter";
import * as ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {checkAndHandleError, fetchDataAsync} from "../../../Services/Utils";

class MasterPart extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        {
            name: "kodePart",
            label: "Kode Part",
        },
        {
            name: "partName",
            label: "Nama Part",
        },
        {
            name: "partCategory",
            label: "Kelompok Part",
        },
        {
            name: "satuan",
            label: "Satuan",
        },
        {
            name: "kodePart",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const status = this.state.dataTable[rowIndex].status;
                    return (
                        <FlexView vAlignContent="center" style={{justifyContent: "space-between"}}>
                            <ToggleButton
                                value={R.equals(status, Status.ACTIVE)}
                                onToggle={(value) =>
                                    this.handleUpdateStatus(val, !value ? Status.ACTIVE : Status.INACTIVE)
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct"
                                onClick={() => this.handleModifyingVisibility(val)}
                                icon={
                                    <i
                                        className="fa fa-lw fa-pencil-alt"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                            <SimpleButton
                                category="action_button"
                                className="btnAct margin-left-15px"
                                onClick={() => this.handleShowAlert(val)}
                                icon={
                                    <i
                                        className="fa fa-trash"
                                        style={{
                                            backgroundColor: "transparent",
                                            color: "red",
                                            fontSize: 20,
                                        }}
                                    />
                                }
                            />
                        </FlexView>
                    );
                },
                setCellProps: () => ({
                    style: {width: "20%"},
                }),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            partName: null,
            deleteId: "",
            loading: false,
            printVisible: false,
            modifyingVisible: false,
            filterVisible: false,
            uploadVisible: false,
            filterData: {},
            submittedFilterData: {},
            selectedData: null,
            isFetch: false,
            pagination: {
                totalData: 0,
                limit: 5,
                page: 1,
            },
            dataTable: [],
            alertCannotDelete: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.isFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
    }

    handleTriggerLoading = () => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
    };

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        this.setState((prevState) => ({
            ...prevState,
            isFetch: true,
            pagination: {...prevState.pagination, totalData: 0},
        }));
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart,
            {paramFilters: {...filter}, page, limit,},
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                    page,
                    limit,
                },
            }));
        }
        this.setState((prevState) => ({...prevState, isFetch: false}));
    };

    handleShowAlert = (id) => {
        if (id) {
            this.setState((prevValue) => ({...prevValue, deleteId: id}));
        } else {
            this.setState((prevValue) => ({...prevValue, deleteId: "",}));
        }
    };

    handleModifyingVisibility = async (id) => {
        this.handleTriggerLoading();
        if (id) {
            let res = await this.callApi(
                Api.create("NAGAMAS_MASTER_DATA").getByKodePart,
                id,
            );
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    selectedData: {
                        ...res.data.data,
                        partCategory: mapToObjectDDL(
                            res.data.data.partCategory.value,
                            res.data.data.partCategory.key
                        ),
                        satuan: mapToObjectDDL(res.data.data.satuan.value, res.data.data.satuan.key),
                        qrCode: res.data.data.qrCode? "YES":"NO"
                    },
                    modifyingVisible: !prevValue.modifyingVisible,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: null,
                modifyingVisible: !prevValue.modifyingVisible,
            }));
        }
        this.handleTriggerLoading();
    };

    handleUpdateStatus = async (id, status) => {
        this.handleTriggerLoading();
        const request = {
            kodePart: id,
            status,
        };
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").updateStatusPart,
            request,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.handleResetAllFilters();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        }
        this.handleTriggerLoading();
    };

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
        }));
    };

    handleUploadVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            uploadVisible: !prevValue.uploadVisible,
        }));
    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            partName: null,
        }));
        let request = removeNullFields({
            ...this.state.filterData,
        });
        if (Object.keys(request).includes("partCategory")) {
            request = {...request, partCategory: getValueFromDDL(request, "partCategory")};
        }
        if (Object.keys(request).includes("satuan")) {
            request = {...request, satuan: getValueFromDDL(request, "satuan")};
        }
        await this.fetchData(removeNullFields(request), 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            filterVisible: false,
            submittedFilterData: request,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSearch = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            filterData: {},
        }));
        const request = removeNullFields({
            partName: !R.isNil(this.state.partName) ? this.state.partName : "",
        });
        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            loading: false,
            submittedFilterData: request,
        }));
    };

    handleShowAlertCannotDelete = () => {
        this.setState((prevValue) => ({...prevValue, alertCannotDelete: !prevValue.alertCannotDelete}));
    };

    handleSubmitDelete = async () => {
        this.handleTriggerLoading();
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").deletePart,
            this.state.deleteId,
        );
        this.handleShowAlert();
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.handleResetAllFilters();
            if (this.state.modifyingVisible) {
                this.handleModifyingVisibility();
            }
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        } else if (res.data.code === 509) {
            this.handleShowAlertCannotDelete();
        }
        this.handleTriggerLoading();
    };

    handleSubmitModifying = async (controls) => {
        this.handleTriggerLoading();
        const formGroup = flattenFormGroupObject(controls);
        console.log(formGroup.qrCode)
        const request = {
            ...formGroup,
            partCategory: formGroup.partCategory.value,
            satuan: formGroup.satuan.value,
            qrCode: formGroup.qrCode === 'YES'
        };
        console.log(request)
        let res = await this.callApi(
            Api.create("NAGAMAS_MASTER_DATA").submitPart,
            request,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            // this.handleResetAllFilters();
            this.handleModifyingVisibility();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
        }
        this.handleTriggerLoading();
    };

    handleSubmitUpload = async (file) => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        try {
            await this.fetchData();
            this.handleUploadVisibility();
        } catch (error) {
            //TODO
        }
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 0,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleDownloadTemplate = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadTemplateMasterPart();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Part")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "TEMPLATE_UPLOAD_PART.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleDownloadLogError = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA_FILE").downloadErrorLogMasterPart();
            if (res.ok) {
                if (checkAndHandleError(res, this.props.setError, "Master Part")) return;
                const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "PART_LOG.xlsx";
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.log("error: ", error);
        }
    }

    handleSubmitFile = async (file) => {
        try {
            this.handleTriggerLoading();
            const renamedFile = new File([file], "PART.xlsx", {
                type: file.type,
            });

            const formData = new FormData();
            formData.append("file", renamedFile);

            let res = await Api.create("NAGAMAS_MASTER_DATA").uploadMasterPart(formData);
            if (res.ok) {
                if (res.data.status === HttpStatus.FAILED || res.data.code === 500 || res.data.data?.code === 500) {
                    this.handleTriggerLoading();
                    return checkAndHandleError(res, this.props.setError, "Master Part");
                }
                if (res.data.data?.status === HttpStatus.FAILED) {
                    this.handleTriggerLoading();
                    return false;
                }
            }
            this.handleTriggerLoading();
            return true;
        } catch (e) {
            console.log("error: ", e);
        }
        this.handleTriggerLoading();
        return false;
    }

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Master Part",
            setError: this.props.setError,
            args: args,
        })
    };

    handleResetAllFilters = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: {},
            namaKas: null,
            submittedFilterData: {},
        }));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center">
                            <SimpleInput
                                id="input_text_part_name"
                                placeholder="Nama Part"
                                name="partName"
                                containerclassname="margin-bottom-5px width width-250px"
                                value={this.state.partName}
                                onChange={({target}) =>
                                    this.setState((prevValue) => ({
                                        ...prevValue,
                                        [target.name]: target.value,
                                    }))
                                }
                            />
                            <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                        </FlexView>
                        <SimpleButton
                            className="btn background-red"
                            category="action_button"
                            onClick={this.handleFilterVisibility}
                            icon={<i className="fa fa-qrcode"></i>}
                        />
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={this.state.pagination.totalData}
                        rowsPerPage={this.state.pagination.limit}
                        page={this.state.pagination.page - 1}
                        options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    icon={<i className="fa fa-plus margin-right-10px"></i>}
                                    onClick={() => this.handleModifyingVisibility()}
                                >
                                    Tambah
                                </SimpleButton>
                                <SimpleButton onClick={this.handleUploadVisibility}>Upload</SimpleButton>
                                <SimpleButton onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                {this.state.printVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
                {this.state.deleteId !== "" && (
                    <SimpleAlert
                        visible={this.state.deleteId !== ""}
                        onClickClose={() => this.handleShowAlert()}
                        content={
                            <div>
                                <p>Apakah anda yakin ingin menghapus data Part ?</p>
                            </div>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                                    Batal
                                </SimpleButton>
                                <SimpleButton onClick={() => this.handleSubmitDelete()}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.uploadVisible && (
                    <SimpleUploadExcel
                        downloadError={true}
                        visible={this.state.uploadVisible}
                        onDownloadTemplate={this.handleDownloadTemplate}
                        onDownloadLogError={this.handleDownloadLogError}
                        onChange={this.handleSubmitFile}
                        onClickClose={this.handleUploadVisibility}
                    />
                )}
                {this.state.modifyingVisible && (
                    <MasterPartModifying
                        formGroup={formGroup} s
                        initialValues={this.state.selectedData}
                        visible={this.state.modifyingVisible}
                        onSubmit={this.handleSubmitModifying}
                        onClickClose={() => this.handleModifyingVisibility()}
                        onDelete={() => this.handleShowAlert(this.state.selectedData?.kodePart)}
                    />
                )}
                {this.state.filterVisible && (
                    <MasterPartFilter
                        visible={this.state.filterVisible}
                        state={this.state}
                        onClickClose={this.handleFilterVisibility}
                        onReset={this.handleResetFilter}
                        onSubmit={this.handleSubmitFilter}
                        onSetState={this.handleStateChange}
                    />
                )}
                {this.state.alertCannotDelete && (
                  <SimpleAlert
                    visible={this.state.alertCannotDelete}
                    onClickClose={() => this.handleShowAlertCannotDelete()}
                    content={
                        <div>
                            <p>Data tidak dapat dihapus, sudah masuk kedalam transaksi.</p>
                        </div>
                    }
                    additionalButtons={
                        <FlexView vAlignContent="center" style={{gap: "10px"}}>
                            <SimpleButton onClick={() => this.handleShowAlertCannotDelete()}>
                                OK
                            </SimpleButton>
                        </FlexView>
                    }/>
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    }
};

export default connect(null, mapDispatchToProps)(MasterPart);
